import {AppPageHeader} from "../../../../core/component/page-header";
import {useHistory, useRouteMatch} from 'react-router-dom';
import React from "react";

export type HeaderFilialProps = {
    createRoute?: string;
    mode?: 'list' | 'form',
    title?: string,
    subTitle?: string,
}

export function HeaderFirm(props: HeaderFilialProps) {
    const urlMatch = useRouteMatch();
    const history = useHistory();

    function getCreateLink(): string {
        return `${urlMatch.url}/create`;
    }

    function getListLink(): string {
        return `list`;
    }
    return (
        <>
            <AppPageHeader
                title={props.title ?? 'Empresas'}
                mode={props.mode}
                subtitle={props.subTitle ?? 'Cadastro de todas as filials do cliente'}
                onCreateLink={getCreateLink()}
                onListLink={getListLink()}
                onBack={() => history.goBack()}
                onCreateLabel={'Adicionar Filial'}
            />
        </>
    );

}
